// Override Settings
var boostPFSFilterConfig = {
    general: {
      limit: typeof boostPFSThemeConfig !== 'undefined' ? boostPFSThemeConfig.custom.products_per_page : 24,
		// Optional
		loadProductFirst: true,
        activeScrollToTop: false,
		showPlaceholderProductList: true,
        capitalizeFilterOptionValues: false
	},
 
};

(function() {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = {},
        minVariant = {},
        showQuickBuy = false;
  
	BoostPFS.inject(this);
    boostPFSFilterConfig.general.separateRefineByFromFilter = jQ('.boost-pfs-filter-tree-h').length > 0 && !Utils.isMobile() ? true : false;
  
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock		
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
      
        showQuickBuy = boostPFSConfig.custom.quick_buy_show && boostPFSConfig.custom.quick_buy_type === 'in-page';
        minVariant = data.variants.reduce(function(current, variant) { return Number(current.price) < Number(variant.price) ? current : variant; }, firstVariant);
        onSale = Number(minVariant.compare_at_price) > Number(minVariant.price); // Check if min price variant is on sale
		return data;
	}  

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		data = prepareShopifyData(data);
		/*** End Prepare data ***/
      
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add soldOut class
		var itemSoldOutClass = soldOut ? 'sold-out' : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);
      
        // Add Desktop class
		itemHtml = itemHtml.replace(/{{itemMaxCols}}/g, boostPFSConfig.custom.products_per_row);
      
        // Add Mobile class
		itemHtml = itemHtml.replace(/{{itemMinCols}}/g, boostPFSConfig.custom.products_per_row_mobile);      
      
        // Add Last class
        var lastClass = this.index === this.parent.data.length - 1 ? 'product-block--last' : '';
		itemHtml = itemHtml.replace(/{{itemLastClass}}/g, lastClass);   
      
        // Add Image Secondary Class
        var secondaryClass = images.length > 1 && boostPFSConfig.custom.product_grid_hover_image ? 'image--with-secondary' : '';
		itemHtml = itemHtml.replace(/{{imageSecondaryImageClass}}/g, lastClass);   
      
        // Add Quick buy class
        var quickBuyClass = showQuickBuy && data.variants.length > 1 && !soldOut ? 'product-block--with-quickbuy' : '';
        itemHtml = itemHtml.replace(/{{itemQuickBuyClass}}/g, lastClass);     
      
        // Add Images
        itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
      
        // Add Labels
        itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));      
      
        // Add Vendor
        var vendorHtml = boostPFSConfig.custom.grid_show_vendor ? boostPFSTemplate.vendorHtml : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, vendorHtml); 
      
        // Add Price
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data)); 
      
        // Stock info
      	var inventory = data.variants.reduce(function(sum, curr) { return sum + curr.inventory_quantity;}, 0);
        itemHtml = itemHtml.replace(/{{StockClass}}/g, inventory > 0 ? 'hc-available' : 'hc-not-available');   

        itemHtml =  itemHtml.replace(/{{StockStatus}}/g, inventory > 0 ?  '<span style="color:rgb(0, 164, 124)">In stock</span>' : '<span style="color:rgb(242, 145, 0)">On request</span>');


		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if(typeof Utils.compileShopifyProductVariables == 'function'){
          itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
        	itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }
      
      	// Last item
        if (this.index === this.parent.data.length - 1) {
          for (var i = 0; i < boostPFSConfig.custom.products_per_row; i++) {
            itemHtml += '<div class="product-block product-block--flex-spacer flex column max-cols-' + boostPFSConfig.custom.products_per_row + ' min-cols-' + boostPFSConfig.custom.products_per_row_mobile + '"></div>';
          }
        }

		return itemHtml;
	}	
    
    function buildImages(data) {
        var aspectRatio = 1;
        var width = 1000;
        var height = 1000;
        var imageAlt = '{{itemTitle}}';

        if (images.length > 0) {
          aspectRatio = images[0]['width'] / images[0]['height'];
          width = images[0].width;     
          height = images[0].height;
          imageAlt = images[0].alt || '';
        }

        var paddingTop = 1 / aspectRatio * 100;
        var imageLazyUrl = Utils.getFeaturedImage(images, '{width}x');
        var imageUrl = Utils.getFeaturedImage(images, '1024x1024');
      
        paddingTop = 100

        var html = '<div class="image__primary">';      
        html += '<div class="rimage-outer-wrapper" style="max-width: {{maxWidth}}px">';
        html += '  <div class="rimage-wrapper lazyload--placeholder" style="padding-top:{{paddingTop}}%">';
        html += '    <img class="rimage__image" data-lazy-src="{{imageLazyUrl}}" loading="lazy" alt="{{imageAlt}}" width="{{imageWidth}}" height="{{imageHeight}}">';
        html += '    <noscript>';
        html += '      <img src="{{imageUrl}}" alt="{{imageAlt}}" class="rimage__image">';
        html += '    </noscript>';
        html += '  </div>';
        html += '</div>';      
        html += '</div>';
      
        html = html.replace(/{{maxWidth}}/g, width);
        html = html.replace(/{{paddingTop}}/g, paddingTop);
        html = html.replace(/{{imageLazyUrl}}/g, imageLazyUrl);
        html = html.replace(/{{imageUrl}}/g, imageUrl);      
        html = html.replace(/{{imageAlt}}/g, imageAlt);          
      
        if (boostPFSConfig.custom.product_grid_hover_image && images.length > 1) {
			html += '<div class="image__secondary">';
            html += '  <div class="rimage-outer-wrapper rimage-background" data-lazy-bg="{{flipLazyUrl}}" data-parent-fit="{{flipFit}}">';
            html += '      <noscript>';
            html += '        <div class="rimage-wrapper" style="padding-top:{{flipPaddingTop}}%">';
            html += '          <img src="{{flipUrl}}" alt="{{flipAlt}}" class="rimage__image">';
            html += '        </div>';
            html += '      </noscript>';
            html += '  </div>';
            html += '</div>';
          
            var flip = images[1];
            aspectRatio = flip.width / flip.height;
            paddingTop = 1 / aspectRatio * 100;
          
            paddingTop = 100
          
            html = html.replace(/{{flipLazyUrl}}/g, Utils.optimizeImage(flip.src, '{width}x'));
            html = html.replace(/{{flipFit}}/g, boostPFSConfig.custom.prod_quick_buy_type === 'hover' && boostPFSConfig.custom.prod_quick_buy_pos === 'bottomcorner' ? 'cover' : 'contain');          
            html = html.replace(/{{flipPaddingTop}}/g, paddingTop);
            html = html.replace(/{{flipUrl}}/g, Utils.optimizeImage(flip.src, '1024x1024'));          
            html = html.replace(/{{flipUrl}}/g, flip.alt || '');                                
        }        

        return html;
    }
  
    function buildLabels(data) {
        var html = '';

        if (soldOut && boostPFSConfig.custom.label_soldout_show) {
          html += boostPFSTemplate.soldOutLabelHtml;
        }

        if (!soldOut && onSale && boostPFSConfig.custom.label_sale_show) {
          html += boostPFSTemplate.saleLabelHtml
          html = html.replace(/{{saveAmount}}/g, Utils.formatMoney(data.compare_at_price_max - data.price_min));
          html = html.replace(/{{percentage}}/g, data.percent_sale_min);        
        }

        if (boostPFSConfig.custom.label_remain_show && firstVariant.inventory_management == 'shopify') {
          var totalInventory = data.variants.reduce(function(sum, variant) { return sum + variant.inventory_quantity }, 0);

          if (totalInventory > 0) {
            if (boostPFSConfig.custom.prod_stock_warn_limit_int === 0 || totalInventory <= boostPFSConfig.custom.prod_stock_warn_limit_int) {
              html += boostPFSTemplate.inventoryLabelHtml;
              html = html.replace(/{{ quantity }}/g, totalInventory);        
            }
          }
        }
      
        if (!html && boostPFSConfig.custom.label_new_in_show) {
			var now_s = new Date().getTime();
			var pub_s = new Date(data.published_at).getTime();
			var diff_days = (now_s - pub_s) / 86400;
			if (diff_days < boostPFSConfig.custom.prod_new_limit_int) {
              html += boostPFSTemplate.newInLabelHtml;
            }
        }

        return html;
    }
  
    function buildPrice(data) {
      	var html = '';
      
        html += '<div class="price {{onSale}}">';
        html += '  {{priceVaries}}';
        html += '  <span class="amount theme-money">{{price}}</span>';
        html += '  {{compareAtPrice}}';      
        html += '</div>';
      
        // Add Sale class 
        var onSaleClass = onSale ? 'on-sale' : '';
        html = html.replace(/{{onSale}}/g, onSaleClass);        
      
      	// Add Price varies
        var priceVariesHtml = priceVaries ? '<span class="from">' + boostPFSConfig.label.from + '</span>' : '';
        html = html.replace(/{{priceVaries}}/g, priceVariesHtml);      
      
        // Add Price
        html = html.replace(/{{price}}/g, Utils.formatMoney(Number(minVariant.price)));      
      
        // Add Compare at Price      
        var compareAtPriceHtml = onSale ? '<del><span class="theme-money">' + Utils.formatMoney(Number(minVariant.price)) + '</span></del>' : '';
        html = html.replace(/{{compareAtPrice}}/g, compareAtPriceHtml);
      
        return html;
    }

	
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li aria-label="' + sortingArr[k] + '"><a href="#" data-sort="' + k + '" class="' + activeClass + '"  title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
      		jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
		});

		jQ(Selector.filterTreeMobileButton).click(function() {
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});

		jQ(document).on('click', function (e) {
          if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
            jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
          }
        });
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
      
        if (boostPFSConfig.custom.quick_buy_show && boostPFSConfig.custom.quick_buy_type === 'in-page') {
          // Call function to get extra product html by ajax
          this.buildExtrasProductListByAjax(data, 'boost-quickbuy', function(results){
            results.forEach(function(result){
             // Append the custom html to product item
             jQ('.boost-pfs-quickbuy-' + result.id).replaceWith(result.quickbuy_html.trim());
            })
          });
        }
		
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		
	};
  
    Filter.prototype.afterRender = function(data) {
      	if (!data) data = this.data;
      
        // Init Sticky Mobile */
        stickyFilterMobile();
        document.addEventListener('scroll', function() {
          stickyFilterMobile();
        });
    }
  
  function stickyFilterMobile() {
    var windowTop = window.pageYOffset || document.body.scrollTop;
    var heightFooter = 0;
    var divTop = 0;
    var divHeight = 0;
    if(jQ("#shopify-section-footer").length > 0){
      heightFooter = jQ("#shopify-section-footer").height();
    }
    if(jQ(".boost-pfs-filter-wrapper").length > 0){
      divTop = jQ('.boost-pfs-filter-wrapper').offset().top;
    }
    if(jQ(".boost-pfs-filter-wrapper").length > 0){
      divHeight = jQ(".boost-pfs-filter-wrapper").height();
    }

    if (windowTop > divTop + divHeight - heightFooter){
        jQ('body').removeClass('boost-pfs-mobile-stick');
    } else if (windowTop > divTop) {
        jQ('body').addClass('boost-pfs-mobile-stick');
    } else {
        jQ('body').removeClass('boost-pfs-mobile-stick');
    }
  }
  
  FilterApi.beforeCall = function() {      
    var urlW = new URL(window.location.href);
    var sort = urlW.searchParams.get('sort_by')

    if (sort) {
      Globals.queryParams.sort = sort;
      urlW.searchParams.delete('sort_by');
      urlW.searchParams.append('sort', sort);
      window.history.pushState('', '', urlW.toString().replace(/\+/g, '%20'));
    }
  }
  
  FilterRefineBy.prototype.afterRender = function() {
    if (this.filterTreeType === FilterTreeEnum.FilterTreeType.HORIZONTAL && this.$element) {
	    this.$element.append('<div style="clear:both;"></div>');
    }
  }
})();